import { instanceOf2cx3k00nj6a0p as instanceOf } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/TypeInfo.web.mjs';
import { get_isSaved1yor47kvbhumv as get_isSaved } from '../plugins/SaveBody.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { HttpResponseContainer3r9yzy4mwwvc9 as HttpResponseContainer } from '../statement/HttpResponsePipeline.mjs';
import { NullBody_instanceoz9dr731l81q as NullBody_instance } from '../../../../../ktor-ktor-http/io/ktor/http/content/OutgoingContent.mjs';
import {
  equals2au1ep9vhcato as equals,
  createThis2j2avj17cvnv2 as createThis,
  captureStack1fzi4aczwc4hg as captureStack,
  toString1pkumu07cwy4m as toString,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { getKClassFromExpression348iqjl4fnx2f as getKClassFromExpression } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import {
  cancel2ztysw4v4hav6 as cancel,
  CoroutineScopefcb5f5dwqcas as CoroutineScope,
} from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CoroutineScope.mjs';
import { PrimitiveClasses_getInstance6p7zmos9nw3c as PrimitiveClasses_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { TypeInfo2nbxsuf4v8os2 as TypeInfo } from '../../../../../ktor-ktor-utils/io/ktor/util/reflect/Type.mjs';
import { AttributeKey3aq8ytwgx54f7 as AttributeKey } from '../../../../../ktor-ktor-utils/io/ktor/util/Attributes.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { atomic$boolean$1iggki4z65a2h as atomic$boolean$1 } from '../../../../../kotlinx-atomicfu/kotlinx/atomicfu/AtomicFU.mjs';
import { throwUninitializedPropertyAccessException14fok093f3k3t as throwUninitializedPropertyAccessException } from '../../../../../kotlin-kotlin-stdlib/kotlin/internal/ThrowHelpers.mjs';
import { DefaultHttpRequest19v463zllbymg as DefaultHttpRequest } from '../request/DefaultHttpRequest.mjs';
import { DefaultHttpResponse2wnrinzo0twhn as DefaultHttpResponse } from '../statement/DefaultHttpResponse.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ByteReadChannel2wzou76jce72d as ByteReadChannel } from '../../../../../ktor-ktor-io/io/ktor/utils/io/ByteReadChannel.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import {
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { get_request3dwcif5y0fvf1 as get_request } from '../statement/HttpResponse.mjs';
import { trimIndent1qytc1wvt8suh as trimIndent } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Indent.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_bodyNullable__6r60mz($this, info, $completion) {
  try {
    if (instanceOf($this.d5g(), info.t4r_1))
      return $this.d5g();
    if (!$this.b5i() && !get_isSaved($this.d5g()) && !$this.z5f_1.atomicfu$compareAndSet(false, true)) {
      throw DoubleReceiveException().y5i($this);
    }
    var tmp0_elvis_lhs = $this.a5i().k4m(Companion_getInstance().z5i_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0 = $this.c5i($completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var responseData = tmp;
    var subject = new (HttpResponseContainer())(info, responseData);
    var tmp_1 = $this.y5f_1.q5f_1.a4r($this, subject, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    // Inline function 'kotlin.takeIf' call
    var this_0 = tmp_1.b5j_1;
    var tmp_2;
    if (!equals(this_0, NullBody_instance)) {
      tmp_2 = this_0;
    } else {
      tmp_2 = null;
    }
    var result = tmp_2;
    if (!(result == null) && !instanceOf(result, info.t4r_1)) {
      var from = getKClassFromExpression(result);
      var to = info.t4r_1;
      throw NoTransformationFoundException().h5j($this.d5g(), from, to);
    }
    return result;
  } catch ($p) {
    if ($p instanceof Error) {
      var cause = $p;
      cancel($this.d5g(), 'Receive failed', cause);
      throw cause;
    } else {
      throw $p;
    }
  }
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        // Inline function 'io.ktor.util.AttributeKey' call
        var name = 'CustomResponse';
        // Inline function 'io.ktor.util.reflect.typeInfo' call
        var tmp_0 = PrimitiveClasses_getInstance().vf();
        // Inline function 'io.ktor.util.reflect.typeOfOrNull' call
        var tmp_1;
        try {
          tmp_1 = createKType(PrimitiveClasses_getInstance().vf(), arrayOf([]), false);
        } catch ($p) {
          var tmp_2;
          if ($p instanceof Error) {
            var _unused_var__etf5q3 = $p;
            tmp_2 = null;
          } else {
            throw $p;
          }
          tmp_1 = tmp_2;
        }
        var tmp$ret$0 = tmp_1;
        var tmp$ret$1 = new (TypeInfo())(tmp_0, tmp$ret$0);
        tmp.z5i_1 = new (AttributeKey())(name, tmp$ret$1);
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpClientCallClass;
function HttpClientCall() {
  if (HttpClientCallClass === VOID) {
    class $ {
      static y5h(client) {
        Companion_getInstance();
        var $this = createThis(this);
        $this.y5f_1 = client;
        $this.z5f_1 = atomic$boolean$1(false);
        $this.c5g_1 = false;
        return $this;
      }
      ew() {
        return this.d5g().ew();
      }
      a5i() {
        return this.z5h().a5i();
      }
      z5h() {
        var tmp = this.a5g_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('request');
        }
      }
      d5g() {
        var tmp = this.b5g_1;
        if (!(tmp == null))
          return tmp;
        else {
          throwUninitializedPropertyAccessException('response');
        }
      }
      static i5j(client, requestData, responseData) {
        Companion_getInstance();
        var $this = this.y5h(client);
        $this.a5g_1 = new (DefaultHttpRequest())($this, requestData);
        $this.b5g_1 = new (DefaultHttpResponse())($this, responseData);
        $this.a5i().o4m(Companion_getInstance().z5i_1);
        var tmp = responseData.n5j_1;
        if (!isInterface(tmp, ByteReadChannel())) {
          $this.a5i().m4m(Companion_getInstance().z5i_1, responseData.n5j_1);
        }
        return $this;
      }
      b5i() {
        return this.c5g_1;
      }
      c5i($completion) {
        return this.d5g().o5i();
      }
      d5i(info, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_bodyNullable__6r60mz.bind(VOID, this, info), $completion);
      }
      toString() {
        return 'HttpClientCall[' + this.z5h().i5i().toString() + ', ' + this.d5g().p5i().toString() + ']';
      }
      e5g(response) {
        this.b5g_1 = response;
      }
    }
    initMetadataForClass($, 'HttpClientCall', VOID, VOID, [CoroutineScope()], [0, 1]);
    HttpClientCallClass = $;
  }
  return HttpClientCallClass;
}
var DoubleReceiveExceptionClass;
function DoubleReceiveException() {
  if (DoubleReceiveExceptionClass === VOID) {
    class $ extends IllegalStateException() {
      static y5i(call) {
        var $this = this.m();
        captureStack($this, $this.x5i_1);
        $this.w5i_1 = 'Response already received: ' + call.toString();
        delete $this.message;
        return $this;
      }
      r() {
        return this.w5i_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'DoubleReceiveException');
    DoubleReceiveExceptionClass = $;
  }
  return DoubleReceiveExceptionClass;
}
var NoTransformationFoundExceptionClass;
function NoTransformationFoundException() {
  if (NoTransformationFoundExceptionClass === VOID) {
    class $ extends UnsupportedOperationException() {
      static h5j(response, from, to) {
        var $this = this.o8();
        captureStack($this, $this.g5j_1);
        $this.f5j_1 = trimIndent("\n        Expected response body of the type '" + toString(to) + "' but was '" + toString(from) + "'\n        In response from `" + get_request(response).i5i().toString() + '`\n        Response status `' + response.p5i().toString() + '`\n        Response header `ContentType: ' + response.a50().l2o('Content-Type') + '` \n        Request header `Accept: ' + get_request(response).a50().l2o('Accept') + '`\n        \n        You can read how to resolve NoTransformationFoundException at FAQ: \n        https://ktor.io/docs/faq.html#no-transformation-found-exception\n    ');
        delete $this.message;
        return $this;
      }
      r() {
        return this.f5j_1;
      }
      get message() {
        return this.r();
      }
    }
    initMetadataForClass($, 'NoTransformationFoundException');
    NoTransformationFoundExceptionClass = $;
  }
  return NoTransformationFoundExceptionClass;
}
//region block: exports
export {
  HttpClientCall as HttpClientCall2j6myj8ctykar,
};
//endregion

//# sourceMappingURL=HttpClientCall.mjs.map
